const QualityControlPermissions = {
  view: 'quality-control:view',
  create: 'quality-control:create',
  edit: 'quality-control:edit',
  delete: 'quality-control:delete',
}

export default QualityControlPermissions
